import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

import { PlatformAdminSystemPromptsPage } from '../../../../components/pages/backoffice/platform/platform-admin-system-prompts-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

/** Optional: lets a deep link (e.g. from the pipeline page's "Open prompt" menu entry) preselect a prompt. */
const searchSchema = type({ 'promptId?': 'string' })

export const Route = createFileRoute('/bo/admin/system-prompts')({
  validateSearch: searchSchema,
  component: function Component() {
    const { promptId } = Route.useSearch()
    return (
      <PermissionChecker requiredPermissions={['tech.configurations']}>
        <PlatformAdminSystemPromptsPage {...(promptId !== undefined ? { initialPromptId: promptId } : {})} />
      </PermissionChecker>
    )
  },
})
